import { createSlice, AnyAction } from "@reduxjs/toolkit";
import type { BannerPosition } from "../types";

const initialState: BannerPosition[] = [];

const bannerPositionsSlice = createSlice({
  name: "bannerPositions",
  initialState: initialState as BannerPosition[],
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase("SET_POSITIONS", (_state, action: AnyAction) => {
      return action.positions;
    });
  },
});

export const selectBannerPositions = (state: {
  bannerPositions: BannerPosition[];
}): BannerPosition[] => state.bannerPositions;

export default bannerPositionsSlice.reducer;
